module.exports = __webpack_public_path__ + "img/patent9.8d039dfb.jpg";